import type { ActionFunctionArgs } from '~/types/route-args';

import { passkeyRegisterVerifyAction } from '~/modules/user/passkey/passkey.server';

export const PASSKEY_REGISTER_VERIFY_API_ROUTE =
    '/remix-api/user/passkey-register-verify';

export const action = (args: ActionFunctionArgs) =>
    passkeyRegisterVerifyAction(args);

export type PasskeyRegisterVerifyAction =
    | {
          ok: true;
          credentialId: string;
          deviceName: string;
          /** The member the credential was written against. */
          memberID?: number;
      }
    | { ok: false; message: string };
